export enum LocationType {
  Unknown = 0,
  Country = 1,
  CountryAlias = 2,
  Airport = 3,
  Nationality = 4,
  IssuingCountry = 5
}
